module.exports = __webpack_public_path__ + "img/instadebit.acb20c0d.svg";